import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { OnyxEvent } from '../../models/event';
import { Reservation } from '../../models/reservation';
import { ReservationFormComponent } from '../reservation-form/reservation-form.component';
import { Observable } from 'rxjs/Observable';
import { EventReservationSource } from '../../models/event-reservation-source';
import { EventReservationAction } from '../../models/event-reservation-action';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'pioneer-reservation-modal',
  templateUrl: './reservation-modal.component.html'
})
export class ReservationModalComponent implements OnInit {

  @ViewChild(ModalDirective)
  public reservationModal: ModalDirective;

  @ViewChild(ReservationFormComponent)
  reservationFormComponent: ReservationFormComponent;

  @Input()
  public config = {
    backdrop: 'static',
    keyboard: false
  };

  @Input()
  event: OnyxEvent;

  @Input()
  action: EventReservationAction;

  title: String;
  placeholder: String;
  reservation: Reservation;

  @Output()
  public closed = new EventEmitter();

  constructor(private translateService: TranslateService) {
  }

  ngOnInit() {
  }

  public open(reservation: Reservation): void {
    if (!this.event) {
      throw new Error('The "event" attribute must be specified to use the ReservationModalComponent component');
    }
    if (!reservation) {
      throw new Error('The "reservation" parameter must be specified to use the ReservationModalComponent component');
    }
    if (!this.action) {
      throw new Error('The "action" attribute must be specified to use the ReservationModalComponent component');
    }

    switch (this.action) {
      case EventReservationAction.EDIT_RESERVATION:
        this.title = this.translateService.instant('EVENT.EDIT_RESERVATION_MODAL.TITLE');
        break;
      case EventReservationAction.RSVP_CONFIRMATION:
        this.title = this.translateService.instant('EVENT.CONFIRM_RESERVATION_MODAL.TITLE');
        this.placeholder = this.translateService.instant('EVENT.CONFIRM_RESERVATION_MODAL.SMALL_TEXT');
        break;
      default:
        throw new Error('The "action" attribute must be specified to use the ReservationModalComponent component');
    }

    this.reservation = reservation;
    this.reservationFormComponent.init(reservation);
    this.reservationModal.show();
  }

  private close(value: boolean): void {
    this.closed.emit(value);
    this.reservationModal.hide();
  }

  public cancel(): void {
    this.reservationFormComponent.cancelAddReservation();
    this.close(false);
  }

  public accept(): Observable<any> {
    let obs: Observable<any> = new Observable();

    switch (this.action) {
      case EventReservationAction.EDIT_RESERVATION:
        obs = this.reservationFormComponent.updateReservation(this.reservation.eventReservationId);
        break;
      case EventReservationAction.RSVP_CONFIRMATION:
        obs = this.reservationFormComponent.addReservation(EventReservationSource.RSVP);
        break;
      default:
        throw new Error('The "action" attribute must be specified to use the ReservationModalComponent component');
    }

    obs.subscribe(() => {
      this.close(true);
    });
    return obs;
  }

  public disableSave(): boolean {
    let disable: boolean;
    if (this.reservationFormComponent && this.reservationFormComponent.reservationForm) {
      disable = !this.reservationFormComponent.reservationForm.valid;
    } else {
      disable = true;
    }
    return disable;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/reservations/reservation-modal/reservation-modal.component.ts